export const categories = [
  {
    id: "cat-1",
    name: "人生轨迹",
    slug: "rensheng-guiji",
    description: "从童年到成名，苍井空完整的人生历程回顾",
    icon: "ri-road-map-line",
    articleCount: 8
  },
  {
    id: "cat-2",
    name: "职业转型",
    slug: "zhiye-zhuanxing",
    description: "从演艺界到艺术领域的华丽蜕变之路",
    icon: "ri-arrow-left-right-line",
    articleCount: 6
  },
  {
    id: "cat-3",
    name: "婚姻生活",
    slug: "hunyin-shenghuo",
    description: "苍井空的婚姻与家庭生活独家揭秘",
    icon: "ri-heart-line",
    articleCount: 5
  },
  {
    id: "cat-4",
    name: "在华影响力",
    slug: "zaihua-yingxiangli",
    description: "苍井空在中国的人气与文化影响力分析",
    icon: "ri-global-line",
    articleCount: 7
  },
  {
    id: "cat-5",
    name: "艺术生涯",
    slug: "yishu-shengya",
    description: "苍井空的绘画、书法等艺术创作与展览",
    icon: "ri-paint-brush-line",
    articleCount: 5
  },
  {
    id: "cat-6",
    name: "最新动态",
    slug: "zuixin-dongtai",
    description: "苍井空近期的新闻、社交媒体动态与社会活动",
    icon: "ri-flashlight-line",
    articleCount: 6
  }
];